// Theme entry script. The `js` class gates any CSS that should only apply
// when JavaScript is available (progressive enhancement hook).
document.documentElement.classList.add('js');

// Form time-trap: stamp every mp-form's hidden `ts` field with the page-load
// time (ms). inc/forms.php rejects submissions filled in under 3s of this
// stamp (bot behavior) or older than 24h (replay) — see its file docblock.
for (const field of document.querySelectorAll('.mp-form input[name="ts"]')) {
  field.value = String(Date.now());
}

/* PAINTINGS FADE IN — the only motion on the site (implementation-spec §5).
 * Each painting (.art-frame, and .paint-fade photos such as the homepage room
 * photo and the product page's in-room view) that starts BELOW
 * the fold gets `.paint-pending` (hidden by the CSS in src/main.css) and then
 * `.is-in` once it enters the viewport: a 400ms opacity + transform fade.
 * Paintings already on screen at load — including the LCP image — are never
 * touched, so nothing visible ever blinks out. Reduced motion, no
 * IntersectionObserver, or no JS: nothing is hidden. Wrapped in an IIFE so
 * nothing leaks to window (theme bundles run as classic scripts). */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  // Automated renders (screenshots, audits) take a full-page capture without
  // scrolling, so an observer would never reveal below-fold paintings there.
  // They get the final state; people get the fade.
  if (navigator.webdriver) return;

  // `.paint-fade` opts a photo in (the homepage room photo, the product
  // page's in-room view).
  var paintings = document.querySelectorAll('.art-frame, .paint-fade');
  if (!paintings.length) return;

  var fold = window.innerHeight || document.documentElement.clientHeight;
  var pending = [];
  paintings.forEach(function (el) {
    if (el.getBoundingClientRect().top < fold) return;
    el.classList.add('paint-pending');
    pending.push(el);
  });
  if (!pending.length) return;

  var observed = false;
  var io = new IntersectionObserver(function (entries, obs) {
    observed = true;
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      obs.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
  pending.forEach(function (el) { io.observe(el); });

  // Safety net: an observer always reports each target's initial state, so
  // if it has not called back at all within 2.5s it is broken — show every
  // painting rather than leave holes in the wall. (Not unconditional: that
  // would pre-empt the fade for anyone who reads the hero before scrolling.)
  window.setTimeout(function () {
    if (observed) return;
    pending.forEach(function (el) { el.classList.add('is-in'); });
  }, 2500);
  // Printing never scrolls: reveal everything first.
  window.addEventListener('beforeprint', function () {
    pending.forEach(function (el) { el.classList.add('is-in'); });
  });
})();

// The product page's frame preview: the picker's choice redraws the frame
// around the painting (src/main.css, "The painting, hung on a wall"). Each
// frame's colours are inline on the figure as --frame-<key>[-l|-r|-b] and
// --frame-<key>-lip[-l|-r|-b].
(function () {
  var art = document.querySelector('.product-art[data-frame]');
  if (!art) return;
  function show(key) {
    art.dataset.frame = key;
    if (key === 'none') return;
    var slots = { c: '', l: '-l', r: '-r', b: '-b', lc: '-lip', ll: '-lip-l', lr: '-lip-r', lb: '-lip-b' };
    Object.keys(slots).forEach(function (slot) {
      art.style.setProperty('--frame-' + slot, 'var(--frame-' + key + slots[slot] + ')');
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'mandy26_frame') show(e.target.value);
  });
  var checked = document.querySelector('input[name="mandy26_frame"]:checked');
  if (checked) show(checked.value);
})();
